import * as Yup from "yup";

import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Axios from "../../utils/axiosInstance";
import {
  disptypedispatchtype,
  selectSitetype,
  selectjobtype,
} from "../SelectOption";
import {
  getCustomerList,
  // getDealerList,
  getDispenserSrNoList,
  getServiceEngineerList,
  getWorkOrderNoList,
} from "../master/AllUserDropDown";
import {
  // getDealerDetailsById,
  getListOfCustomerById,
  getListOfUserById,
} from "../../Service/AllAccessGetById";
import {
  getDispatchListByDispenserSrNo,
  getDispenserSrNoDropDList,
  getWorkOrderNoDropDown,
} from "../../Service/AllWorkOrder";
import {
  getDispenserDropDownListForFieldJob,
  getWorkOrderFieldSrNo,
  postWorkOrderFieldIssue,
} from "../../Service/AllWorkOrderFieldIssueAPI";

import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";

const pincodeRegEx = "^[1-9]{1}[0-9]{2}[0-9]{3}$"; //validate PinCode

/* declaration of validationSchema
validation (based on the object schema provided by Yup) and display of validation errors */
// const validationSchema = Yup.object({
//   serviceEngineerName: Yup.string().required("Required *"),
//   jobPreference: Yup.string().required("Required *"),
//   // oprationType: Yup.string().required("Required *"),
//   // subOprationType: Yup.string().required("Required *"),
//   // siteType: Yup.string().required("Required *"),
//   // siteLocation: Yup.string().required("Required *"),
//   // address: Yup.string().required("Required *"),
//   // city: Yup.string().required("Required *")
//   //   .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
//   //   .min(2, "Too Short!"),
//   // pincode: Yup.string()
//   //   .required("Required *")
//   //   .matches(pincodeRegEx, "Pincode is not valid"),
//   description: Yup.string()
//     .required("Required *")
//     .min(4, "It should have minimum 4 characters!")
//     .max(225, "It should have maximum 225 characters!"),
// });

const getValidationSchema = (otpType) =>
  Yup.object({
    // serviceEngineerName: Yup.string().required("Required *"),
    jobPreference: Yup.string().required("Required *"),

    oprationType: Yup.string().when([], {
      is: () => otpType === "OTP",
      then: schema => schema.required("Required *"),
      otherwise: schema => schema.notRequired(),
    }),

    subOprationType: Yup.string().when([], {
      is: () => otpType === "OTP",
      then: schema => schema.required("Required *"),
      otherwise: schema => schema.notRequired(),
    }),

    description: Yup.string()
      .required("Required *")
      .min(4, "It should have minimum 4 characters!")
      .max(225, "It should have maximum 225 characters!"),
  });


export default () => {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [customerName, setCustomerName] = useState([]);
  // const [dealerName, setDealerName] = useState([]);
  const [userMblNo, setUserMblNo] = useState("");
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
  const [jobType, setjobType] = useState("field visit");
  const [workOrderSrNo, setworkOrderSrNo] = useState("");
  const [workOrderNo, setWorkOrderNo] = useState([]);
  const [dispenserSrNo, setDispenserSrNo] = useState("");
  const [selectDispenserSrNo, setSelectDispenserSrNo] = useState("");
  const [allDispenserData, setAllDispenserData] = useState({});
  const [status, setStatus] = useState("ready to sale");
  const [disabled, setdisabled] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  const [newdispenserNo, setNewDispenserNo] = useState([]);
  const [selected, setSelected] = useState("");
  let type = null;
  // const [showdealer, setShowDealer] = useState(false);
  const [customerFullName, setCustomerFullName] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [startDate, setStartDate] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [siteType, setSiteType] = useState(""); // Store the siteType
  const clean = (v) => (v ?? "").replace(/\r?\n|\r/g, "").trim();
  const location = useLocation();


  const searchParams = new URLSearchParams(location.search);
  const dispenser = searchParams.get("dispenser") || "N/A";
  const ticketNumber = searchParams.get("ticket") || "N/A";
  const priority = searchParams.get("priority") || "N/A";
  const roCountry = searchParams.get("roCountry") || "N/A";
  const roCity = searchParams.get("roCity") || "N/A";
  const roState = searchParams.get("roState") || "N/A";
  const roDistrict = searchParams.get("roDistrict") || "N/A";
  const roAddress = searchParams.get("roAddress") || "N/A";
  const pincode = searchParams.get("pincode") || "N/A";
  // const issues = searchParams.get("issues") || "N/A";
  const issuesParam = searchParams.get("issues");
  const roSiteType = searchParams.get("roSiteType") || "N/A";
  const roContact = searchParams.get("roContact") || "N/A";
  const contactPerson = searchParams.get("contactPerson") || "N/A";
  const roEmail = searchParams.get("roEmail") || "N/A";
  const seName = searchParams.get("seName") || "N/A";
  const seEmail = searchParams.get("seEmail") || "N/A";
  const seContactNumber = searchParams.get("seContactNumber") || "N/A";
  const seId = searchParams.get("seId") || "N/A";
  const pkUserId = searchParams.get("pkUserId") || "N/A";

  let issues = [];
  try {
    issues = issuesParam
      ? JSON.parse(decodeURIComponent(issuesParam))
      : [];
  } catch (err) {
    console.error("Invalid issues param:", issuesParam);
  }



  console.log("Dispenser:", dispenser);
  console.log("Ticket Number:", ticketNumber);
  console.log("Priority:", priority);
  console.log("roCountry:", roCountry);
  console.log("roCity :", roCity);
  console.log("roState:", roState);
  console.log("roDistrict:", roDistrict);
  console.log("roAddress", roAddress);
  console.log("pincode", pincode);
  console.log("issues", issues);
  console.log("roSiteType", roSiteType);

  console.log("roContact", roContact);
  console.log("contactPerson", contactPerson);
  console.log("roEmail", roEmail);
  console.log("seName", seName);
  console.log("seEmail", seEmail);
  console.log("seContactNumber", seContactNumber);
  console.log("seId", seId);
  console.log("pkUserId", pkUserId);


  // const [formValues, setFormValues] = useState({
  //   dispenserSrNo: dispenser,
  //   ticketNumber: ticketNumber,
  //   priority: priority,
  //   roCountry: roCountry,
  //   roState: roState,
  //   roAddress: roAddress,
  //   roCity: roCity,
  //   pincode: pincode,
  //   issues: issues,
  // });


  const [formValues, setFormValues] = useState({
    dispenserSrNo: clean(dispenser),
    ticketNumber: clean(ticketNumber),
    priority: clean(priority),
    roCountry: clean(roCountry),
    roDistrict: clean(roDistrict),
    roState: clean(roState),
    roCity: clean(roCity),
    roAddress: clean(roAddress),
    pincode: clean(pincode),
    roSiteType: clean(roSiteType),
    issues: issues,
    roContact: clean(roContact),
    contactPerson: clean(contactPerson),
    roEmail: clean(roEmail),
    seName: clean(seName),
    seContactNumber: clean(seContactNumber),
    seEmail: clean(seEmail),
    pkUserId: clean(pkUserId),
         seId:clean(seId),
    // roContact: clean(roContact),
    // contactPerson: clean(contactPerson),
    // roSiteType: clean(roSiteType),
  });

  const otpType = formValues.issues?.[0]?.otpType || "";


  const issueNames = formValues.issues
    ?.map(issue => issue.partName)
    .join(", ");



  // const changeHandler = (e) => {
  //   setSiteType(e.value); // Store the selected siteType
  //   if (e.value === "COCO") {
  //     setShowDealer(false);
  //   } else {
  //     setShowDealer(true);
  //   }
  // };

  // as per fecthed roSiteType
  // useEffect(() => {
  //   if (formValues.roSiteType === "COCO") {
  //     setShowDealer(false);
  //   } else {
  //     setShowDealer(true);
  //   }
  // }, [formValues.roSiteType]);


  // const validateMobile = (value) => {
  //   let error;
  //   if (!value) {
  //     error = "Mobile number is required";
  //   } else if (!/^[0-9\s]+$/.test(value)) {
  //     error = "Enter numbers only";
  //   } else {
  //     const cleanedNumber = value.replace(/\s/g, ""); // Remove spaces
  //     if (!/^\d{10}$/.test(cleanedNumber)) {
  //       error = "Mobile number must be exactly 10 digits";
  //     } else if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
  //       error = "Invalid mobile number ";
  //     }
  //   }
  //   return error;
  // };

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute, second] = time24.split(":");
    const parsedHour = parseInt(hour, 10);
    const period = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
    return `${formattedHour}:${minute}:${second} ${period}`;
  };

  const displayFormattedTime = selectedTime
    ? formatTimeTo12Hour(selectedTime)
    : "";

  useEffect(() => {
    // Function call to get customers,Dealers and  Service Engineers list
    getCustomersList();
    // getDealersList();
    getServiceEngineersList();
    getWorkOrderList();
    getDispenserSrNoAllList();
  }, []);



  useEffect(() => {
    if (!otpType || !customerFullName) return;

    if (otpType !== "OTP") {
      generateWorkOrder("NA");
    }
  }, [otpType, customerFullName]);



  // useEffect(() => {
  //   document.addEventListener("keydown", function (event) {
  //     if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
  //       var form = event.target.form;
  //       var index = Array.prototype.indexOf.call(form, event.target);
  //       form.elements[index + 1].focus();
  //       event.preventDefault();
  //     }
  //   });
  // }, []);


  // added this code because of naivagiton error was coimng in ticket service page
  useEffect(() => {
    const handleEnterKey = (event) => {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        const form = event.target.form;

        if (form && form.elements) {
          const index = Array.prototype.indexOf.call(form.elements, event.target);
          if (form.elements[index + 1]) {
            form.elements[index + 1].focus();
            event.preventDefault();
          }
        }
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, []);

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };


  const generateWorkOrder = (operationTypeValue) => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      getWorkOrderFieldSrNo(
        "field visit",
        operationTypeValue,
        customerFullName,
        headers
      )
        .then((result) => {
          console.log("Work Order Generated:", result);
          setworkOrderSrNo(result.data);
        })
        .catch((error) => {
          console.log("Work Order Error:", error);
        });
    } catch (error) {
      console.log("generateWorkOrder error:", error);
    }
  };

  // const generateWorkOrder = (operationTypeValue) => {
  //   try {
  //     const token = sessionStorage.getItem("token");
  //     const headers = { Authorization: `Bearer ${token}` };

  //     if (otpType === "NON_OTP") {

  //       Axios.get(
  //         `/workorder/getWorkOrderSerialNumber?jobType=field visit&customerName=${customerFullName}`,
  //         { headers }
  //       )
  //         .then((result) => {
  //           console.log("Work Order Generated:", result);
  //           setworkOrderSrNo(result.data);
  //         })
  //         .catch((error) => {
  //           console.log("Work Order Error:", error);
  //         });

  //     } else {

  //       getWorkOrderFieldSrNo(
  //         "field visit",
  //         operationTypeValue,
  //         customerFullName,
  //         headers
  //       )
  //         .then((result) => {
  //           console.log("Work Order Generated:", result);
  //           setworkOrderSrNo(result.data);
  //         })
  //         .catch((error) => {
  //           console.log("Work Order Error:", error);
  //         });
  //     }

  //   } catch (error) {
  //     console.log("generateWorkOrder error:", error);
  //   }
  // };


  // Function declaration of get dealers list
  // const getDealersList = async () => {
  //   await getDealerList().then((result) => {
  //     setDealerName(result);
  //   });
  // };

  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };

  const getDispenserSrNoAllList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getDispenserDropDownListForFieldJob(headers)
        .then((result) => {
          if (result?.data?.length) {
            console.log("getDispenserDDLFFieldJob result :-", result);
            let tempDispenserArray = result.data.map((no) => {
              return {
                value: `${no}`,
                label: `${no}`,
              };
            }).reverse();

            setDispenserSrNo(tempDispenserArray);
            console.log("getDispenserDDLFFieldJob array :-", dispenserSrNo);
          }
        })
        .catch((error) => {
          console.log("getDispenserDDLFFieldJob error :-", error);
        });
      return setDispenserSrNo;
    } catch (error) {
      console.log("getDispenserDDLFFieldJob error :-", error);
    }
  };

  const getWorkOrderList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      // const status= ["ready to install"]
      await getWorkOrderNoDropDown(status, headers)
        .then((result) => {
          if (result?.data?.length !== 0) {
            console.log("Work Order List", result.data);
            let tempServiceArray = result.data.map((obj) => {
              // let Name = obj.split(",");
              return {
                id: `${obj}`,
                value: `${obj}`,
                label: `${obj}`,
              };
            });
            setWorkOrderNo(tempServiceArray);
            console.log("Work OrderNo DropDown", result.data);
          }
        })
        .catch((error) => {
          console.log("Work Order List Error", error);
        });
      return setWorkOrderNo;
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    if (!dispenser) return;

    console.log("FIELD JOB DISPENSER:", dispenser);

    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    getDispatchListByDispenserSrNo(dispenser)
      .then((res) => {
        if (!res?.data?.length) return;

        const data = res.data[0];

        console.log("Field Job Customer Data:", data);

        setAllDispenserData(data);
        setCustomerFullName(data.customerFullName);

        setFormValues((prev) => ({
          ...prev,
          dispenserSrNo: dispenser,
          customerName: data.customerFullName || "",
          customerNumber: data.customerMobileNo || "",
        }));
      })
      .catch((err) => {
        console.error("Field Job Error:", err);
        swal("Failed", "Something went wrong", "error");
      });
  }, [dispenser]);


  const selectOTPtype = [
    { value: "Marry New Hardware", label: "Hardware Change" },
    { value: "Marry New Firmware", label: "Firmware Change" },
    { value: "Rate Change", label: "Rate Change" },
    { value: "Supervisor Unlock", label: "Supervisor Unlock" },
    { value: "Clear magnet error", label: "Clear magnet error" },
    { value: "Date Change", label: "Date Change" },
    { value: "Time Change", label: "Time Change" },
    {
      value: "Reconnect MRE (Pulsar)",
      label: "Reconnect MRE (Pulsar)",
    },

    { value: "Reconnect CSD", label: "Reconnect CSD" },
    { value: "Reconnect LKD", label: "Reconnect LKD" },
    { value: "Reconnect ETOT", label: "Reconnect ETOT" },
    { value: "Reconnect PVR", label: "Reconnect PVR" },
    { value: "Reconnect PRN", label: "Reconnect PRN" },
    {
      value: "Suspicious Communication Detected",
      label: "Suspicious Communication Detected",

    },
    {
      value: "Reconnect Feature Enable / Disable", label: "Reconnect Feature Enable / Disable"
    },
    { value: "To Open ERA Front Door", label: "To Open ERA Front Door" },
    { value: "To Close ERA Front Door", label: "To Close ERA Front Door" },
    { value: "To Open ERA Rear Door", label: "To Open ERA Rear Door" },
    { value: "To Close ERA Rear Door", label: "To Close ERA Rear Door" },
    {
      value: "To Mandate Pulsar Back To Mapped Nozzle",
      label: "To Mandate Pulsar Back To Mapped Nozzle",

    },


    // { value: "hangingHardwareChange", label: "Hanging Hardware Change"}
  ];

  // const disabledOptions = [15, 16, 17, 18, 19]; just commented for now to enable all options in the dropdown
    const disabledOptions = [20, 21, 22, 23, 24];

  const MarryNewBoard = [
    { value: "ETOT/MEM Board", label: "ETOT/MEM Board" },
    { value: "CSD Board", label: "CSD Board" },
    { value: "LKD Board", label: "LKD Board" },
    { value: "MCU Board", label: "MCU Board" },
    { value: "MRE (Pulsar) Board", label: "MRE (Pulsar) Board" },
    { value: "PRN Board", label: "PRN Board" },
    { value: "PVR Board", label: "PVR Board" },
  ];

  const MarryNewHardware = [
    { value: "ETOT/MEM Board", label: "ETOT/MEM Board" },
    { value: "CSD Board", label: "CSD Board" },
    { value: "LKD Board", label: "LKD Board" },
    { value: "MCU Board", label: "MCU Board" },
    { value: "MRE (Pulsar) Board", label: "MRE (Pulsar) Board" },
    { value: "PRN Board", label: "PRN Board" },
    { value: "PVR Board", label: "PVR Board" },
  ];

  const startCalibration = [
    { value: "Nozzle 1", label: "Nozzle 1" },
    { value: "Nozzle 2", label: "Nozzle 2" },
    { value: "Nozzle 3", label: "Nozzle 3" },
    { value: "Nozzle 4", label: "Nozzle 4" },
    { value: "Nozzle 5", label: "Nozzle 5" },
    { value: "Nozzle 6", label: "Nozzle 6" },
    { value: "Nozzle 7", label: "Nozzle 7" },
    { value: "Nozzle 8", label: "Nozzle 8" },
  ];

  const endCalibration = [
    { value: "Nozzle 1", label: "Nozzle 1" },
    { value: "Nozzle 2", label: "Nozzle 2" },
    { value: "Nozzle 3", label: "Nozzle 3" },
    { value: "Nozzle 4", label: "Nozzle 4" },
    { value: "Nozzle 5", label: "Nozzle 5" },
    { value: "Nozzle 6", label: "Nozzle 6" },
    { value: "Nozzle 7", label: "Nozzle 7" },
    { value: "Nozzle 8", label: "Nozzle 8" },
  ];

  const rateChange = [
    // { value: "Concerned Product", label: "Concerned Product" },
    { value: "Nozzle 1", label: "Nozzle 1" },
    { value: "Nozzle 2", label: "Nozzle 2" },
    { value: "Nozzle 3", label: "Nozzle 3" },
    { value: "Nozzle 4", label: "Nozzle 4" },
    { value: "Nozzle 5", label: "Nozzle 5" },
    { value: "Nozzle 6", label: "Nozzle 6" },
    { value: "Nozzle 7", label: "Nozzle 7" },
    { value: "Nozzle 8", label: "Nozzle 8" },
    // { value: "Product No. 1", label: "Product No 1" },
    // { value: "Product No. 2", label: "Product No 2" },
    // { value: "Product No. 3", label: "Product No 3" },
    // { value: "Product No. 4", label: "Product No 4" },
  ];

  const supervisorUnlock = [
    { value: "Supervisor Unlock", label: "Supervisor Unlock" },
  ];

  const clearmagneterror = [
    { value: "MRE (Pulsar) Board 1", label: "MRE (Pulsar) Board 1" },
    { value: "MRE (Pulsar) Board 2", label: "MRE (Pulsar) Board 2" },
    { value: "MRE (Pulsar) Board 3", label: "MRE (Pulsar) Board 3" },
    { value: "MRE (Pulsar) Board 4", label: "MRE (Pulsar) Board 4" },
    { value: "MRE (Pulsar) Board 5", label: "MRE (Pulsar) Board 5" },
    { value: "MRE (Pulsar) Board 6", label: "MRE (Pulsar) Board 6" },
    { value: "MRE (Pulsar) Board 7", label: "MRE (Pulsar) Board 7" },
    { value: "MRE (Pulsar) Board 8", label: "MRE (Pulsar) Board 8" },
  ];

  const toMandatepulsarbacktomappednozzle = [
    { value: "Nozzle 1", label: "Nozzle 1" },
    { value: "Nozzle 2", label: "Nozzle 2" },
    { value: "Nozzle 3", label: "Nozzle 3" },
    { value: "Nozzle 4", label: "Nozzle 4" },
    { value: "Nozzle 5", label: "Nozzle 5" },
    { value: "Nozzle 6", label: "Nozzle 6" },
    { value: "Nozzle 7", label: "Nozzle 7" },
    { value: "Nozzle 8", label: "Nozzle 8" },
  ];

  const dateChange = [{ value: "Date Change", label: "Date Change" }];

  const timeChange = [{ value: "Time Change", label: "Time Change" }];


  const OpenERADoor =[{ value: "To Open ERA Front Door", label: "To Open ERA Front Door" }];
  const CloseERADoor =[{ value: "To Close ERA Front Door", label: "To Close ERA Front Door" }];
  const OpenHydraulicDoor =[{ value: "To Open ERA Rear Door", label: "To Open ERA Rear Door" }];
  const CloseHydraulicDoor =[{ value: "To Close ERA Rear Door", label: "To Close ERA Rear Door" }];
  const ToMandatePulsar =[{ value: "To Mandate Pulsar Back To Mapped Nozzle", label: "To Mandate Pulsar Back To Mapped Nozzle" }];





  // const hangingHardwareChange = [
  //   {value: "mcuChange", label: "MCU Change"},
  //   {value: "totChange", label: "TOT Change"},
  //   {value: "lkdChange", label: "LKD Change"},
  // ];

  //Conditon for operation Type filter

  const reconnectCsd = [
    { value: "CSD Board 0", label: "CSD Board 0" },
    { value: "CSD Board 1", label: "CSD Board 1" },
    { value: "CSD Board 2", label: "CSD Board 2" },
    { value: "CSD Board 3", label: "CSD Board 3" }
  ];
  const reconnectLkd = [
    { value: "LKD Board 0", label: "LKD Board 0" },
    { value: "LKD Board 1", label: "LKD Board 1" },
    { value: "LKD Board 2", label: "LKD Board 2" },
    { value: "LKD Board 3", label: "LKD Board 3" }
  ];
  const reconnectEtot = [
    { value: "ETOT Board_", label: "ETOT Board" },

  ];
  const reconnectPvr = [
    { value: "PVR Board_", label: "PVR Board" },

  ];
  const reconnectPrn = [
    { value: "PRN Board 0", label: "PRN Board 1" },
    { value: "PRN Board 1", label: "PRN Board 2" },

  ];

  const SuspiciousBoard = [
    { value: "Suspicious Communication Detected", label: "Suspicious Communication Detected" },


  ];

  const ReconnectenableDisable = [
    { value: "Enable", label: "Reconnect Feature Enable" },
    { value: "Disable", label: "Reconnect Feature Disable" },


  ];

  if (selected === "Marry New Hardware") {
    type = MarryNewHardware;
  } else if (selected === "Marry New Firmware") {
    type = MarryNewBoard;
  } else if (selected === "Calibration Start") {
    type = startCalibration;
  } else if (selected === "End Calibration") {
    type = endCalibration;
  } else if (selected === "Rate Change") {
    type = rateChange;
  } else if (selected === "Supervisor Unlock") {
    type = supervisorUnlock;
  } else if (selected === "Clear magnet error") {
    type = clearmagneterror;
  } else if (selected === "Reconnect MRE (Pulsar)") {
    type = clearmagneterror;
  } else if (selected === "To Open ERA Front Door") {
    type = OpenERADoor;
  } else if (selected === "To Close ERA Front Door") {
    type = CloseERADoor;
  } else if (selected === "To Open ERA Rear Door") {
    type = OpenHydraulicDoor;
  } else if (selected === "To Close ERA Rear Door") {
    type = CloseHydraulicDoor;
  } else if (selected === "To Mandate Pulsar Back To Mapped Nozzle") {
    type = ToMandatePulsar;
  } else if (selected === "Date Change") {
    type = dateChange;
  } else if (selected === "Time Change") {
    type = timeChange;
  } else if (selected === "Reconnect CSD") {
    type = reconnectCsd;
  } else if (selected === "Reconnect LKD") {
    type = reconnectLkd;
  } else if (selected === "Reconnect PRN") {
    type = reconnectPrn;
  } else if (selected === "Reconnect PVR") {
    type = reconnectPvr;
  } else if (selected === "Reconnect ETOT") {
    type = reconnectEtot;
  } else if (selected === "Suspicious Communication Detected") {
    type = SuspiciousBoard;
    // } else if (selected === "hangingHardwareChange") {
    //   type = hangingHardwareChange;
  }

  else if (selected === "Reconnect Feature Enable / Disable") {

    type = ReconnectenableDisable;
  }





  return (
    <Formik //Formik provides the Form, Field and ErrorMessage
      initialValues={{
        //declaration of initialValues
        generateUniqueDispenserNo: "",
        fieldVisitDate: "",
        fieldVisitTime: "",
        serviceEngineerName: "",
        serviceEngineerMobNo: "",
        // RoManagerEmail: "",
        // RoManagerMobNo: "",
        // RoManagerName: "",

         roManagerName:"",
        roManagerEmail:"",
        roManagerMobNo:"",
        fkRoManagerId:"",
        siteType: "",
        otpType: "",
        selectedIssue: "",
        jobPreference: "",
        oprationType: "",
        customerName: "",
        subOprationType: "",
        customerMobNo: "",
        // dealerName: "",
        // dealerMobNo: "",
        // dealerName: allDispenserData.dealerName || "",
        // mobileNo: allDispenserData?.mobileNo || "",
        siteLocation: "",
        dispenserType: "",
        address: "",
        description: "",
        roDistrict: "",
        dispenserSrNo: "",
        ticketNumber: "",
        priority: "",
        roCountry: "",
        roCity: "",
        roState: "",
        roAddress: "",
        pincode: "",
      }}
      validationSchema={getValidationSchema(otpType)}// function call to validationSchema
      onSubmit={async (values, { resetForm }) => {
        // declaration of onSubmit callback
        try {
          // code that we will 'try' to run

          const pkUserId = sessionStorage.getItem("pkUserId");
          const role = sessionStorage.getItem("role");
          setisLoaded(true);
          setdisabled(true);
          const data = {
            // All Object for add Field data
            workOrderSerialNo: workOrderSrNo,
            // generateUniqueDispenserNo: values.generateUniqueDispenserNo,
            fieldVisitDate: moment(selectedDate, "DD/MMM/yyyy").format(
              "yyyy-MM-DD"
            ),
            // fieldVisitTime: displayFormattedTime,
            fieldVisitTime: moment(displayFormattedTime, "hh:mm:ss A").format(
              "hh:mm:ss A"
            ),
            fkServiceEngineerId: formValues.seId,
            fkCustomerId: allDispenserData.fkCustomerId,
            // fkDealerId: allDispenserData.fkDealerId,
            fkBackOfficeId: role === "back office" ? pkUserId : "",
            // serviceEngineerName: values.serviceEngineerName,
            // serviceEngineerMobNo: userMblNo,
            // siteLocation: values.siteLocation,
            serviceEngineerName: formValues.seName,
            serviceEngineerMobNo: formValues.seContactNumber,
            roManagerName: formValues.contactPerson,
            roManagerMobNo: formValues.roContact,
            roManagerEmail: formValues.roEmail,
            siteLocation: formValues.roAddress,
            fkRoManagerId: formValues.pkUserId,
            jobPreference: values.jobPreference,
            // oprationType: values.oprationType,
            // subOprationType: values.subOprationType,
            oprationType: otpType === "OTP" ? values.oprationType : "NA",
            subOprationType: otpType === "OTP" ? values.subOprationType : "NA",
            selectedIssue: issueNames,

            // siteType: values.siteType,
            siteType: formValues.roSiteType,
            customerName: allDispenserData.customerFullName,
            customerMobNo: allDispenserData.customerMobileNo,
            // dealerName: allDispenserData.dealerName,
            // dealerMobNo: allDispenserData.mobileNo,
            // dealerName: values.siteType === "COCO" ? "" : values.dealerName, // Set null if COCO
            // dealerMobNo: values.siteType === "COCO" ? "" : values.mobileNo, // Set null if COCO
            jobType: jobType,
            otpType: otpType,
            dispenserType: allDispenserData.modelName,
            address: formValues.roAddress,
            country: formValues.roCountry,
            roDistrict: formValues.roDistrict,
            state: formValues.roState,
            city: formValues.roCity,
            pincode: formValues.pincode,
            description: values.description,
            // generateUniqueDispenserNo: formValues.dispenserSrNo,
            generateUniqueDispenserNo: clean(formValues.dispenserSrNo),
            ticketNumber: formValues.ticketNumber,
            priority: formValues.priority,
            roCity: formValues.roCity,
            roAddress: formValues.roAddress,
            roState: formValues.roState,
            roCountry: formValues.roCountry,
            // pincode: formValues.pincode,
          };
          console.log("Work Order Field Job Data", data);

          await postWorkOrderFieldIssue(data)
            .then((result) => {
              console.log("Work Order Field Job", result);
              setisLoaded(false);
              swal("Great", "Field Job Work order created successfully...", "success");
              resetForm()
              // setTimeout(() => {
              //   resetForm();
              // window.location.href = '/Callcenter/TicketServiceTech';
              // }, 5000);
            })
            .catch((error) => {
              setisLoaded(false);
              console.log("Work Order Field Issue Error :-", error);
              if (error.response.status === 400) {
                console.log("error.response.data :-", error.response.data);
                let fieldVal = error?.response?.data;
                if (fieldVal?.generateUniqueDispenserNo !== undefined) {
                  swal("Failed", "Please Enter Dispenser Sr No", "warning");
                  return false;
                }
                if (fieldVal?.serviceEngineerName !== undefined) {
                  swal(
                    "Failed",
                    "Please Enter Service Engineer Name",
                    "warning"
                  );
                  return false;
                }
                if (fieldVal?.serviceEngineerMobNo !== undefined) {
                  swal(
                    "Failed",
                    "Please Enter Service Engineer Mobile No",
                    "warning"
                  );
                  return false;
                }
                if (fieldVal?.siteType !== undefined) {
                  swal("Failed", "Please Select Site Type", "warning");
                  return false;
                }
                if (fieldVal?.dispenserType !== undefined) {
                  swal("Failed", "Please Enter Dispenser Type", "warning");
                  return false;
                }

                if (fieldVal?.pincode !== undefined) {
                  swal("Failed", "Please Enter Pincode", "warning");
                  return false;
                }
              } else {
                swal(
                  "Failed",
                  "Something went wrong please check your internet",
                  "error"
                );
              }
            });
        } catch (error) {
          //code to run if there are any problems
          console.log(error);
          setisLoaded(false);
          swal(
            "Failed",
            "Something went wrong please check your internet",
            "error"
          );
        }
      }}
    >
      {(formik) => {
        //Formik provides the Form, Field and ErrorMessage
        const { isValid, dirty, isSubmitting, handleChange, values, setFieldValue, errors, touched } = formik;
        const isfieldjobbutton = selectedDate && displayFormattedTime;

        // const dealerCheck = formValues.roSiteType !== "COCO"
        //   ? values.dealerName && values.mobileNo
        //   : true;  // If siteType is COCO, dealerName and mobileNo are not required
        // // If siteType is COCO, dealerName and mobileNo are not required

        // useEffect(() => {
        //   if (allDispenserData?.dealerName) {
        //     setFieldValue("dealerName", allDispenserData.dealerName);
        //   }
        //   if (allDispenserData?.mobileNo) {
        //     setFieldValue("mobileNo", allDispenserData.mobileNo);
        //   }
        // }, [allDispenserData, setFieldValue]);

        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    {/* <button className="btn btn-primary"> */}
                    <Link
                      to="field-job-list"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                    {/* </button> */}
                  </div>
                </div>

                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="head mb-4">Create Field Job Work Order</h5>
                    <h5 className="SrNo mb-4" align="right">
                      Field Visit Sr No : {workOrderSrNo}
                    </h5>
                    {/* react-final-form */}
                    <Form>
                      <Row>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Dispenser Sr No

                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.dispenserSrNo}
                              readOnly
                            />
                          </div>
                        </Col>




                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Ticket Number
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.ticketNumber}
                              readOnly
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Priority

                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.priority}
                              readOnly
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> Dispenser Config</label>
                            <Field
                              type="text"
                              className="form-control"
                              id="dispenserType"
                              placeholder=" Dispenser Config"
                              value={allDispenserData.modelName}
                              readOnly
                            // options={disptypedispatchtype}
                            // onChange={(e) => {
                            //   formik.setFieldValue("dispenserType", e.value);
                            // }}
                            />
                          </div>
                        </Col>


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Field Job Date *{" "}
                            </label>
                            <br />
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Field Job Date"
                                direction="bottom"
                              >
                                <DatePicker
                                  showIcon
                                  closeOnScroll={true}
                                  className="form-control"
                                  dateFormat="dd-MMM-yyyy"
                                  placeholderText="Select Field Job Date"
                                  selected={selectedDate}
                                  onChange={(date) => {
                                    setSelectedDate(date);
                                  }}
                                  // minDate={new Date()} // Set the minimum selectable date to today
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Field Job Time *{" "}
                            </label>
                            <br />
                            <div className="time-wrapper">
                              <div className="allTime">
                                <input
                                  type="time"
                                  onChange={handleTimeChange}
                                  className="form-control"
                                  step="1"
                                />
                              </div>
                              <div className="addTime">
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Time from Widget"
                                    direction="bottom"
                                  >
                                    <Field
                                      className="form-control"
                                      name="fieldVisitTime"
                                      placeholder="Select Time"
                                      value={displayFormattedTime}
                                      readOnly
                                    />
                                  </ToolTip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Service Engineer Name *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Service Engineer Name"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Service Engineer Name"
                                  options={serviceEngineerName}
                                  onChange={async (e) => {
                                    formik.setFieldValue(
                                      "serviceEngineerName",
                                      e.value
                                    );
                                    setSelectedServiceEngineer(e.id);
                                    const token =
                                      sessionStorage.getItem("token");
                                    const headers = {
                                      Authorization: `Bearer ${token}`,
                                    };
                                    await getListOfUserById(e.id, headers).then(
                                      (result) => {
                                        console.log(
                                          "getListOfUserById",
                                          result.data
                                        );
                                        setUserMblNo(result.data.mobileNo);
                                      }
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="serviceEngineerName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Service Engineer Mobile No{" "}
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="serviceEngineerMobNo"
                              value={userMblNo}
                              placeholder="Mobile No."
                              readOnly
                            />
                          </div>
                        </Col> */}

                        <Col md={6} className="mb-3">

                          <div className="form-group">
                            <label className="Label mb-1">  Service Engineer Name</label>
                            <div className="example-wrapper">


                              <Field
                                type="text"
                                className="form-control"


                                value={formValues.seName}
                                readOnly
                              />

                            </div>

                          </div>

                        </Col>

                        <Col md={6} className="mb-3">


                          <div className="form-group">
                            <label className="Label mb-1">  Service Engineer Mobile No</label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.seContactNumber}
                                readOnly
                              />

                            </div>

                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Name </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.contactPerson}
                                readOnly
                              />

                            </div>

                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Mobile Number </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.roContact}
                                readOnly
                              />

                            </div>

                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Email </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.roEmail}
                                readOnly
                              />

                            </div>

                          </div>
                        </Col>



                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Job Reference *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Job Reference"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Job Reference"
                                  options={selectjobtype}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "jobPreference",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="jobPreference"
                              component={TextError}
                            />
                          </div>
                        </Col>


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Job Type
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              value={otpType}
                              readOnly
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Issue Reported Name
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              value={issueNames}
                              readOnly
                            />
                          </div>
                        </Col>

                        {otpType === "OTP" ?
                          <>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">
                                  {" "}
                                  Operation Type *{" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Operation Type"
                                    direction="bottom"
                                  >
                                    <Select
                                      name="oprationType"
                                      placeholder="Select Operation Type"
                                      options={selectOTPtype}
                                      // onChange={changeSelectOptionHandler}
                                      isOptionDisabled={(option) =>
                                        disabledOptions.includes(
                                          selectOTPtype.indexOf(option)
                                        )
                                      }
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "oprationType",
                                          e.value
                                        );
                                        setSelected(e.value);
                                        generateWorkOrder(e.value);
                                        try {
                                          const token =
                                            sessionStorage.getItem("token");
                                          const headers = {
                                            Authorization: `Bearer ${token}`,
                                          };
                                          const customerName = customerFullName;
                                          const oprationType = e.value;
                                          getWorkOrderFieldSrNo(
                                            "field visit",
                                            oprationType,
                                            customerName,
                                            headers
                                          )
                                            .then((result) => {
                                              console.log(
                                                "Work Order Field Visit Sr No",
                                                result
                                              );
                                              setworkOrderSrNo(result.data);
                                            })
                                            .catch((error) => {
                                              console.log(
                                                "Work Order Field Visit Error",
                                                error
                                              );
                                            });
                                        } catch (error) {
                                          console.log(
                                            "getWorkOrderFieldSrNo :-",
                                            error
                                          );
                                        }
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="oprationType"
                                  component={TextError}
                                />
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">
                                  {" "}
                                  Sub Operation Type *{" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Sub Operation"
                                    direction="bottom"
                                  >
                                    <Select
                                      name="subOprationType"
                                      placeholder="Select Sub Operation"
                                      options={type}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "subOprationType",
                                          e.value
                                        );
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="subOprationType"
                                  component={TextError}
                                />
                              </div>
                            </Col>
                          </>
                          : ""}
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Select Site Type *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Site Type"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Site Type"
                                  options={selectSitetype}
                                  onChange={(val) => {
                                    changeHandler(val);
                                    formik.setFieldValue("siteType", val.value);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteType"
                              component={TextError}
                            />
                          </div>
                        </Col> */}



                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Labelmb-1">Site Type </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.roSiteType}
                                readOnly
                              />

                            </div>
                            <ErrorMessage name="roSiteType" component={TextError} />
                          </div>
                        </Col>
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Site Location *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Site Location"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="siteLocation"
                                  placeholder="Site Location"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteLocation"
                              component={TextError}
                            />
                          </div>
                        </Col> */}
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Customer Name{" "}
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Customer Name"
                              value={allDispenserData.customerFullName}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Customer Mobile No
                            </label>
                            <Field
                              type="text"
                              name="customerMobNo"
                              value={allDispenserData.customerMobileNo}
                              className="form-control"
                              placeholder="Customer Mobile No"
                              readOnly
                            />
                          </div>
                        </Col>
                        {/* {showdealer ? (
                          <>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Dealer Name{" "}
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Dealer Name"
                                  name="dealerName"
                                  autoComplete="off"
                                  // value={allDispenserData.dealerName}
                                  value={values.dealerName}
                                  onChange={handleChange}
                                // readOnly
                                />
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">

                              <div className="form-group">
                                <label className="Label mb-1">Dealer Mobile No</label>
                                <Field
                                  type="text"
                                  name="mobileNo"
                                  autoComplete="off"
                                  maxLength="10"
                                  className={`form-control ${errors.mobileNo && touched.mobileNo ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter Dealer Mobile No"
                                  validate={validateMobile}
                                />
                                <ErrorMessage name="mobileNo" component="div" className="text-danger" />
                              </div>
                            </Col>
                          </>
                        ) : null} */}


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO Country</label>
                            <div className="example-wrapper">
                              {/* <ToolTip
                                content="Select Country"
                                direction="bottom"
                              >
                                <CountryDropdown
                                  className="form-control"
                                  id="country"
                                  value={country}
                                  onChange={(val) => setCountry(val)}
                                  priorityOptions={["IN"]}
                                />
                              </ToolTip> */}
                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.roCountry}
                                readOnly
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO State</label>
                            <div className="example-wrapper">
                              {/* <ToolTip
                                content="Select State"
                                direction="bottom"
                              >
                                <RegionDropdown
                                  className="form-control"
                                  id="state"
                                  country={country}
                                  value={state}
                                  onChange={(val) => setState(val)}
                                />
                              </ToolTip> */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                value={formValues.roState}
                                readOnly
                              />
                            </div>
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO District</label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"
                                value={formValues.roDistrict}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO City </label>
                            <div className="example-wrapper">
                              <ToolTip content="Enter City" direction="bottom">
                                <Field
                                  type="text"
                                  className="form-control"

                                  value={formValues.roCity}
                                  readOnly
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              RO Address {" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Site Address"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  maxLength={100}
                                  className="form-control"

                                  value={formValues.roAddress}
                                  readOnly
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="address"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO Pincode </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"
                                // name="pincode"
                                // placeholder="Enter Pin Code"
                                // maxLength="6"
                                // autoComplete="off"
                                value={formValues.pincode}
                                readOnly
                              />

                            </div>

                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Description *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Description"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="4"
                                  maxLength={100}
                                  className="form-control"
                                  name="description"
                                  placeholder="Enter Description"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="description"
                              component={TextError}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || !isfieldjobbutton /* || !dealerCheck */}
                        >
                          Create Field Job WO
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};

